module.exports = __webpack_public_path__ + "img/Experiment Information.763675c1.png";